module.exports = __webpack_public_path__ + "img/login-theme6.90c839dd.svg";